export const state = {
  product: null,
  productDifference: {},
  activeProductDifference: {},
  riskTypeDifference: {},
  riskTypesTree: null,
  activeRiskTypesTreeNodeId: null,
  productMapping: {}
}
